import React, { useState, useEffect } from 'react';

import { Typography, notification, Row, Col, Button } from 'antd';

import { FormattedMessage, useIntl } from 'react-intl';

import _service from '@netuno/service-client';

import ToConsumeItems from './ToConsumeItems';

const { Text } = Typography;

export default ({ radius }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uid, setUID] = useState(null);
    const [showMarketplaceWasteType, setShowMarketplaceWasteType] = useState(false);
    useEffect(() => {
        setLoading(true);
        setUID(null);
        _service({
            method: 'GET',
            url: '/marketplace/waste/consume/type/list',
            data: { radius },
            success: (response) => {
                setData(response.json);
                setLoading(false);
            },
            fail: (e) => {
                setLoading(false);
                notification["error"]({
                    message: 'Não foi possivel carregar os dados.',
                    description: e.response.json.error,
                });
            }
        });
    }, [radius]);

    const intl = useIntl();

    const onShowCard = (item) => {
        setUID(item.uid);
        setShowMarketplaceWasteType(false)
    }

    return (
        uid && !showMarketplaceWasteType ? <ToConsumeItems wasteTypeUID={uid} radius={radius} setShowMarketplaceWasteType={setShowMarketplaceWasteType} /> :
            <div className="marketplace__waste__type">
                {data.map((item) => (
                    <>
                        <Row>
                            <Col span={16}>
                                <Text level={5}>{item.code}</Text>
                                <Button type='text' level={3} onClick={() => onShowCard(item)} size='large'>{item.description[intl.locale.split('-')[0]]}</Button>
                            </Col>
                            <Col span={8}><Text level={5}>{item.total}</Text></Col>
                        </Row>
                        <br />
                    </>
                ))}
            </div>
    )
}